import { Button, Stack } from "@mui/material";
import Layout from "./components/Layout";
import { Link } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { useContext, useEffect } from "react";
import UserContext from "../../services/Context/UserContext";
import API from "../../services/API";
import VerifyingProof from "../Tools/VerifyingProof";

export default function Etudiant() {

    const { user } = useContext(UserContext);

    useEffect(() => {

        API.post(`/crm/users/${user?.id}/student-proof/email`)
            .then(r => console.log(r.data))
            .catch(e => console.log(e?.response?.data))

    }, [user]);

    return (
        <Layout center>

            <Stack sx={{ maxWidth: 600, margin: 'auto' }} spacing={1}>

                <VerifyingProof />

                <Button component={Link} to="/" startIcon={<ArrowBack />}>
                    Retour à l'accueil
                </Button>

            </Stack>

        </Layout>
    );
}